var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('el-popover',{staticStyle:{"margin-left":"10px","cursor":"pointer"},attrs:{"placement":_vm.placement,"title":"提示","width":"200","trigger":"hover","content":_vm.content}},[_c('i',{staticClass:"el-icon-info",attrs:{"slot":"reference"},slot:"reference"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }